// package: order_publisher
// file: order-publisher.proto

var order_publisher_pb = require("./order-publisher_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var common_pb = require("./common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var PublisherApiService = (function () {
  function PublisherApiService() {}
  PublisherApiService.serviceName = "order_publisher.PublisherApiService";
  return PublisherApiService;
}());

PublisherApiService.getPublisherWebsites = {
  methodName: "getPublisherWebsites",
  service: PublisherApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_publisher_pb.PublisherWebsitePageRequest,
  responseType: order_publisher_pb.PublisherWebsiteResponse
};

PublisherApiService.createPublisherWebsite = {
  methodName: "createPublisherWebsite",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteCreateRequest,
  responseType: order_publisher_pb.PublisherWebsiteDetailsResponse
};

PublisherApiService.updatePublisherWebsite = {
  methodName: "updatePublisherWebsite",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteUpdateRequest,
  responseType: order_publisher_pb.PublisherWebsiteDetailsResponse
};

PublisherApiService.deletePublisherWebsite = {
  methodName: "deletePublisherWebsite",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: google_protobuf_empty_pb.Empty
};

PublisherApiService.getPublisherWebsiteDetails = {
  methodName: "getPublisherWebsiteDetails",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_publisher_pb.PublisherWebsiteDetailsResponse
};

PublisherApiService.calcPublisherWebsitePrice = {
  methodName: "calcPublisherWebsitePrice",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteCalcPriceRequest,
  responseType: order_publisher_pb.PublisherWebsiteCalcPriceResponse
};

PublisherApiService.changePublisherWebsiteStatus = {
  methodName: "changePublisherWebsiteStatus",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteChangeStatusRequest,
  responseType: google_protobuf_empty_pb.Empty
};

PublisherApiService.getPublisherWebsiteVerificationOptions = {
  methodName: "getPublisherWebsiteVerificationOptions",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_publisher_pb.PublisherWebsiteVerificationContainer
};

PublisherApiService.verifyPublisherWebsite = {
  methodName: "verifyPublisherWebsite",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteVerificationRequest,
  responseType: order_publisher_pb.PublisherWebsiteVerificationResponse
};

PublisherApiService.sendPublisherWebsiteVerificationEmail = {
  methodName: "sendPublisherWebsiteVerificationEmail",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteSendVerificationEmailRequest,
  responseType: google_protobuf_empty_pb.Empty
};

PublisherApiService.getPublisherWebsiteImportTemplate = {
  methodName: "getPublisherWebsiteImportTemplate",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: common_pb.FileResponse
};

PublisherApiService.launchPublisherWebsiteImport = {
  methodName: "launchPublisherWebsiteImport",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteImportLaunchRequest,
  responseType: order_publisher_pb.PublisherWebsiteImportResponse
};

PublisherApiService.getPublisherWebsiteImport = {
  methodName: "getPublisherWebsiteImport",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_publisher_pb.PublisherWebsiteImportResponse
};

PublisherApiService.getLatestPublisherWebsiteImport = {
  methodName: "getLatestPublisherWebsiteImport",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherWebsiteImportLatestRequest,
  responseType: order_publisher_pb.PublisherWebsiteImportResponse
};

PublisherApiService.cancelPublisherWebsiteImport = {
  methodName: "cancelPublisherWebsiteImport",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: order_publisher_pb.PublisherWebsiteImportResponse
};

PublisherApiService.downloadPublisherWebsiteImportReport = {
  methodName: "downloadPublisherWebsiteImportReport",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: common_pb.FileResponse
};

PublisherApiService.getPublisherOrders = {
  methodName: "getPublisherOrders",
  service: PublisherApiService,
  requestStream: false,
  responseStream: true,
  requestType: order_publisher_pb.PublisherOrderPageRequest,
  responseType: order_publisher_pb.PublisherOrderResponse
};

PublisherApiService.changePublisherOrderStatus = {
  methodName: "changePublisherOrderStatus",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherOrderStatusRequest,
  responseType: google_protobuf_empty_pb.Empty
};

PublisherApiService.updateOrderPublishedUrl = {
  methodName: "updateOrderPublishedUrl",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.PublisherOrderPublishedUrlRequest,
  responseType: google_protobuf_empty_pb.Empty
};

PublisherApiService.getOrderChangeRequest = {
  methodName: "getOrderChangeRequest",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.GetChangeRequestRequest,
  responseType: order_publisher_pb.ChangeRequestResponse
};

PublisherApiService.submitOrderChanges = {
  methodName: "submitOrderChanges",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.SubmitChangesRequest,
  responseType: order_publisher_pb.ChangeRequestResponse
};

PublisherApiService.addPublisherChangeRequestMessage = {
  methodName: "addPublisherChangeRequestMessage",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.AddChangeRequestMessageRequest,
  responseType: order_publisher_pb.ChangeRequestResponse
};

PublisherApiService.submitNewLiveLink = {
  methodName: "submitNewLiveLink",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.SubmitNewLiveLinkRequest,
  responseType: order_publisher_pb.ChangeRequestResponse
};

PublisherApiService.markOrderChangeRequestSeen = {
  methodName: "markOrderChangeRequestSeen",
  service: PublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: order_publisher_pb.MarkChangeRequestSeenRequest,
  responseType: order_publisher_pb.ChangeRequestResponse
};

exports.PublisherApiService = PublisherApiService;

function PublisherApiServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

PublisherApiServiceClient.prototype.getPublisherWebsites = function getPublisherWebsites(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(PublisherApiService.getPublisherWebsites, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.createPublisherWebsite = function createPublisherWebsite(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.createPublisherWebsite, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.updatePublisherWebsite = function updatePublisherWebsite(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.updatePublisherWebsite, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.deletePublisherWebsite = function deletePublisherWebsite(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.deletePublisherWebsite, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getPublisherWebsiteDetails = function getPublisherWebsiteDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getPublisherWebsiteDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.calcPublisherWebsitePrice = function calcPublisherWebsitePrice(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.calcPublisherWebsitePrice, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.changePublisherWebsiteStatus = function changePublisherWebsiteStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.changePublisherWebsiteStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getPublisherWebsiteVerificationOptions = function getPublisherWebsiteVerificationOptions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getPublisherWebsiteVerificationOptions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.verifyPublisherWebsite = function verifyPublisherWebsite(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.verifyPublisherWebsite, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.sendPublisherWebsiteVerificationEmail = function sendPublisherWebsiteVerificationEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.sendPublisherWebsiteVerificationEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getPublisherWebsiteImportTemplate = function getPublisherWebsiteImportTemplate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getPublisherWebsiteImportTemplate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.launchPublisherWebsiteImport = function launchPublisherWebsiteImport(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.launchPublisherWebsiteImport, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getPublisherWebsiteImport = function getPublisherWebsiteImport(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getPublisherWebsiteImport, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getLatestPublisherWebsiteImport = function getLatestPublisherWebsiteImport(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getLatestPublisherWebsiteImport, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.cancelPublisherWebsiteImport = function cancelPublisherWebsiteImport(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.cancelPublisherWebsiteImport, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.downloadPublisherWebsiteImportReport = function downloadPublisherWebsiteImportReport(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.downloadPublisherWebsiteImportReport, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getPublisherOrders = function getPublisherOrders(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(PublisherApiService.getPublisherOrders, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.changePublisherOrderStatus = function changePublisherOrderStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.changePublisherOrderStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.updateOrderPublishedUrl = function updateOrderPublishedUrl(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.updateOrderPublishedUrl, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.getOrderChangeRequest = function getOrderChangeRequest(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.getOrderChangeRequest, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.submitOrderChanges = function submitOrderChanges(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.submitOrderChanges, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.addPublisherChangeRequestMessage = function addPublisherChangeRequestMessage(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.addPublisherChangeRequestMessage, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.submitNewLiveLink = function submitNewLiveLink(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.submitNewLiveLink, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

PublisherApiServiceClient.prototype.markOrderChangeRequestSeen = function markOrderChangeRequestSeen(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(PublisherApiService.markOrderChangeRequestSeen, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.PublisherApiServiceClient = PublisherApiServiceClient;

